import { create } from "zustand";

interface IState {
  scrolls: {
    [key: string]: number;
  };
  scrollElement: HTMLElement | null;
  setScroll: (key: string, value: number) => void;
  setScrollElement: (element: HTMLElement | null) => void;
}

export const useScrollStore = create<IState>(
  (set) => ({
    scrolls: {},
    scrollElement: null,
    setScroll: (key, value) => {
      set(({ scrolls }) => ({
        scrolls: {
          ...scrolls,
          [key]: value,
        }
      }));
    },
    setScrollElement: (scrollElement) => set(() => ({ scrollElement }))
  }),
);
